import { render, staticRenderFns } from "./SingleOrderTemplate.vue?vue&type=template&id=2721913c&"
import script from "./SingleOrderTemplate.vue?vue&type=script&lang=js&"
export * from "./SingleOrderTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports